<template>
  <div>
    <DataList :data="conductorConfig" :attributes="attributes" />
    <RawJsonToggler :json="conductorConfig" />
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import DataList from '@/components/DataList.vue'
import RawJsonToggler from '@/components/RawJsonToggler.vue'

export default {
  name: 'ConductorApiConfig',
  data() {
    return {
      attributes: [
        { name: 'version', type: 'text' },
        { name: 'buildDate', type: 'text' }
      ]
    }
  },
  computed: mapState(['conductorConfig']),
  methods: mapActions(['getConductorConfig']),
  created() {
    this.getConductorConfig()
  },
  components: {
    DataList,
    RawJsonToggler
  }
}
</script>
